import React from 'react';
import { layoutConfig } from 'config/table-configs/ar-list';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsArEntityWidget as MemberDetailsArEntityWidget } from 'ui/views/memberDetailsAREntityWidget';
 *
 * // render
 * <MemberDetailsArEntityWidget propName='propValue'/>
 */
export const memberDetailsArEntityWidgetSuccess = ( props ) => {
    return (
        <div className='ui-member-details-ar-entity-widget'>
            <TableSearchWidget
                layoutConfig={layoutConfig}
                templateType='inline'
                onActionClick={props.onActionClick}
                tableResponse={props.componentData}
                requestPayload={props.requestPayload}
                sortFilterMode='offline'
                searchFilter={ 'offline' }
                disablePagination={true}
            />
        </div>
    );
};

// set display name
memberDetailsArEntityWidgetSuccess.displayName = 'memberDetailsArEntityWidgetSuccess';

// set default props
memberDetailsArEntityWidgetSuccess.defaultProps = {};

// prop types
memberDetailsArEntityWidgetSuccess.propTypes = {};

export const memberDetailsArEntityWidgetPreloader = () => {
    return (
        <div className='ui-member-details-ar-entity-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-ar-entity-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsArEntityWidgetPreloader.displayName = 'memberDetailsArEntityWidgetPreloader';

// set default props
memberDetailsArEntityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsArEntityWidgetPreloader.propTypes = {};

export const memberDetailsArEntityWidget = withNetworkState( memberDetailsArEntityWidgetPreloader, memberDetailsArEntityWidgetSuccess );

